import * as React from "react";
import { forwardRef } from "react";
const SvgLoading = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "animate-spin", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.6216 8C15.6216 3.79072 12.2093 0.378418 8 0.378418", stroke: "currentColor", strokeWidth: 0.75, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgLoading);
export default ForwardRef;
